






import Vue from 'vue';
import store from '@/store';

import { Badge, BasePacket, BasePacketKind } from '@/models/packet';

export default Vue.extend({
  methods: {
    async copySet(selectedBasePacket: BasePacket) {
      if (selectedBasePacket.kind === BasePacketKind.SINGLE_POINT) {
        store.dispatch.singlePoint.reset();

        const objectiveId = selectedBasePacket.objectives[0].objectiveId;

        await store.dispatch.badges.fetchBadges(objectiveId);

        const badges = store.state.badges.badges[objectiveId];

        // A SINGLE_POINT packet starts out with an objective, so
        // we just update that objective instead of creating a new one.
        const newObjective = store.state.singlePoint.packet.objectives[0];

        store.dispatch.singlePoint.updateSinglePointBasicInfo({
          ...newObjective,
          name: selectedBasePacket.name + ' copy',
          description: selectedBasePacket.description,
          iconData: selectedBasePacket.objectives[0].iconData
        });

        selectedBasePacket.outcomes.forEach(outcome => {
          const badge = badges.find(b => b.outcomeId === outcome.outcomeId);

          store.dispatch.singlePoint.insertOutcome({
            index: outcome.sortOrder,
            value: outcome.value,
            color: outcome.color,
            iconData: outcome.iconData,
            badgeDescription: badge?.description || ''
          });
        });

        this.$emit('completed', BasePacketKind.SINGLE_POINT);
      } else {
        // Multi point
        store.dispatch.multiPoint.reset();

        const objectiveIds = selectedBasePacket.objectives.map(
          o => o.objectiveId
        );

        await Promise.all(objectiveIds.map(store.dispatch.badges.fetchBadges));

        store.dispatch.multiPoint.updateMultiPointBasicInfo({
          ...selectedBasePacket,
          name: selectedBasePacket.name + ' copy'
        });

        selectedBasePacket.objectives.forEach(obj =>
          store.dispatch.multiPoint.createObjective({
            name: obj.name,
            description: obj.description,
            iconData: obj.iconData
          })
        );

        selectedBasePacket.outcomes.forEach(outcome =>
          store.dispatch.multiPoint.createMultiPointIndicator({
            index: outcome.sortOrder,
            value: outcome.value,
            color: outcome.color
          })
        );

        const newPacket = store.state.multiPoint.packet;

        // After we generate new objectives and outcomes, we can't match them to the
        // appropriate badge description (because they get new ids).
        //
        // So we build a description lookup map keyed on the objective.name and the
        // outcome.value
        const nameValueDescriptionMap: {
          [key: string]: { [key: string]: string };
        } = {};

        selectedBasePacket.objectives.forEach(obj => {
          nameValueDescriptionMap[obj.name] = {};

          selectedBasePacket.outcomes.forEach(outcome => {
            nameValueDescriptionMap[obj.name][outcome.value] =
              store.state.badges.badges[obj.objectiveId].find(
                badge => badge.outcomeId === outcome.outcomeId
              )?.description ?? 'No description';
          });
        });

        const lookupDescription = (badge: Badge): string => {
          const objective = newPacket.objectives.find(
            obj => obj.objectiveId === badge.objectiveId
          );
          const outcome = newPacket.outcomes.find(
            outcome => outcome.outcomeId === badge.outcomeId
          );

          if (!objective || !outcome) {
            return '';
          }

          return nameValueDescriptionMap[objective.name][outcome.value];
        };

        store.state.multiPoint.badges.forEach(badge =>
          store.dispatch.multiPoint.updateBadge({
            ...badge,
            description: lookupDescription(badge)
          })
        );

        this.$emit('completed', BasePacketKind.MULTI_POINT);
      }
    }
  }
});
